<template>
  <div style="display: flex;">
    <div v-if="show" class="img_box">
      <img class="top_img" src="@/assets/juece.png" alt="" />
      <img class="bottom_img" src="@/assets/nongshi.png" alt="" />
    </div>

    <ul class="timeline-wrapper" @scroll="scrollEvent" ref="outsideWrap" @mousewheel="ONMouseWheel($event)">
      <div>
        <li class="timeline-item" v-for="item in timelineList" :key="item.id">
          <div class="timeline-box">
            <div class="out-circle">
              <div class="in-circle"></div>
              <div class="timeline-date">
                <el-popover placement="bottom" title="作物" width="200" trigger="hover" :content="item.content">
                  <el-button type="text" slot="reference" class="father-text">{{ item.date }}</el-button>
                </el-popover>
              </div>
            </div>
            <div class="long-line" v-show="item.isShow">
              <div v-for="subItem in item.children" :key="subItem.id" :class="`${subItem.istop == 1 ? 'sub-item-box' : 'bottom-item-box'}`">
                <!-- {{subItem.istop == 1 && subItem.attributeName.includes('土壤') }} -->
                <span v-if="subItem.istop == 1">{{ subItem.name }} </span>

                <div class="children-line-box "></div>
                <!-- 根据奇数偶数来判断向上还是向下 -->
                <div v-if="subItem.istop == 1 && subItem.all" class="sub-line-box bottom-line-box  toper_gj">
                  <!-- v-if="subItem.istop == 2" class="sub-line-box bottom-line-box" -->
                  <div class="children-box toper-gj-box a895">
                    <div style="margin-top: 0.5rem;">
                      <!-- <div>
                      {{ subItem.content }}
                    </div> -->
                      <div>
                        {{ subItem.attributeName }}
                      </div>
                      <div class="b69 a895" style="margin-top:-5px">告警数值： {{ subItem.value }}</div>
                      <span class="b69 a895">时间: {{ subItem.operation }} </span>
                      <!-- <span class="b69">时间: {{ subItem.operation }} </span> -->
                    </div>
                  </div>
                </div>
                <div v-if="subItem.istop == 1 && subItem.alarm == 2" class="sub-line-box top-line-box ">
                  <div class="children-box top-children-box  a89">
                    <div>
                      <!-- <div>
                      {{ subItem.content }}
                    </div> -->
                      <div>
                        {{ subItem.attributeName }}
                      </div>
                      <span class="b69 ">时间: {{ subItem.operation }} </span>
                      <!-- <div style="font-size: 13px;margin-top: 0.2rem;">

                    </div> -->
                    </div>
                  </div>
                </div>
                <div v-if="subItem.istop == 3" class="sub-line-box top-line-box  toper_gj_  none">
                  <div class="children-box toper-gj-box_ a895">
                    <div style="margin-top: 0.5rem;">
                      <!-- <div>
                      {{ subItem.content }}
                    </div> -->
                      <div>
                        {{ subItem.attributeName }}
                      </div>
                      <div class="b69 a895" style="margin-top:-5px">提醒内容： {{ subItem.value }}</div>
                      <span class="b69 a895">提醒时间: {{ subItem.operation }} </span>

                      <!-- <span class="b69">时间: {{ subItem.operation }} </span> -->
                    </div>
                  </div>
                </div>
                <div v-if="subItem.istop == 2" class="sub-line-box bottom-line-box none">
                  <div class="children-box bottom-children-box">
                    <div class="text_content">
                      <div class="ns_title">
                        <img class="ns_img" :src="subItem.workTypeImage" alt="" />
                        <span>{{ subItem.workType }}—{{ subItem.cropName }}—{{ subItem.groupName }}</span>
                      </div>

                      <div class="title_box" v-if="subItem.workContent">
                        <div class="title_" style="margin-top:3px">
                          {{ subItem.workContent }}
                        </div>
                      </div>
                      <!-- <div>
                      作业总量:{{ subItem.workInputName }}{{ subItem.workInputQuantity }}{{ subItem.unit }}
                    </div> -->

                      <div style="display: flex;margin-bottom: 0.5rem;margin-top: 0.5rem;">
                        <el-image v-if="subItem.workImage.includes(',')" style="height: 40px" v-for="(item, index) in subItem.workImage.split(',')" :key="index" :src="item != undefined ? item : ''" :preview-src-list="subItem.workImage != undefined ? subItem.workImage.split(',') : []" fit="contain"> </el-image>
                        <el-image v-else style="height: 40px" :src="subItem.workImage" :preview-src-list="subItem.workImage" fit="contain"> </el-image>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </div>
      <div>
        <li class="timeline-item2" v-for="item in timelineList" :key="item.id">
          <div class="timeline-box">
            <div class="out-circle">
              <div class="in-circle"></div>
              <div class="timeline-date">
                <el-popover placement="bottom" title="作物" width="200" trigger="hover" :content="item.content">
                  <el-button type="text" slot="reference" class="father-text">{{ item.date }}</el-button>
                </el-popover>
              </div>
            </div>
            <div class="long-line" v-show="item.isShow">
              <div v-for="subItem in item.children" :key="subItem.id" :class="`${subItem.istop == 3 ? 'sub-item-box' : 'bottom-item-box'}`">
                <!-- {{subItem.istop == 1 && subItem.attributeName.includes('土壤') }} -->
                <span v-if="subItem.istop == 3">{{ subItem.name }} </span>
                <span v-if="subItem.istop == 2">{{ subItem.name }} </span>
                <div class="children-line-box "></div>
                <!-- 根据奇数偶数来判断向上还是向下 -->
                <div v-if="subItem.istop == 1 && subItem.all" class="sub-line-box bottom-line-box  toper_gj none">
                  <!-- v-if="subItem.istop == 2" class="sub-line-box bottom-line-box" -->
                  <div class="children-box toper-gj-box a895">
                    <div style="margin-top: 0.5rem;">
                      <!-- <div>
                      {{ subItem.content }}
                    </div> -->
                      <div>
                        {{ subItem.attributeName }}
                      </div>
                      <div class="b69 a895" style="margin-top:-5px">告警数值： {{ subItem.value }}</div>
                      <span class="b69 a895">时间: {{ subItem.operation }} </span>
                      <!-- <span class="b69">时间: {{ subItem.operation }} </span> -->
                    </div>
                  </div>
                </div>
                <div v-if="subItem.istop == 1 && subItem.alarm == 2" class="sub-line-box top-line-box none ">
                  <div class="children-box top-children-box  a89">
                    <div>
                      <!-- <div>
                      {{ subItem.content }}
                    </div> -->
                      <div>
                        {{ subItem.attributeName }}
                      </div>
                      <span class="b69 ">时间: {{ subItem.operation }} </span>
                      <!-- <div style="font-size: 13px;margin-top: 0.2rem;">

                    </div> -->
                    </div>
                  </div>
                </div>
                <div v-if="subItem.istop == 3" class="sub-line-box top-line-box  toper_gj_">
                  <div class="children-box toper-gj-box_ a895">
                    <div style="margin-top: 0.5rem;">
                      <!-- <div>
                      {{ subItem.content }}
                    </div> -->
                      <div>
                        {{ subItem.attributeName }}
                      </div>
                      <div class="b69 a895" style="margin-top:-5px">提醒内容： {{ subItem.value }}</div>
                      <span class="b69 a895">提醒时间: {{ subItem.operation }} </span>

                      <!-- <span class="b69">时间: {{ subItem.operation }} </span> -->
                    </div>
                  </div>
                </div>
                <div v-if="subItem.istop == 2" class="sub-line-box bottom-line-box">
                  <div class="children-box bottom-children-box">
                    <div class="text_content">
                      <div class="ns_title">
                        <img class="ns_img" :src="subItem.workTypeImage" alt="" />
                        <span>{{ subItem.workType }}—{{ subItem.cropName }}—{{ subItem.groupName }}</span>
                      </div>

                      <div class="title_box" v-if="subItem.workContent">
                        <div class="title_" style="margin-top:3px">
                          {{ subItem.workContent }}
                        </div>
                      </div>
                      <!-- <div>
                      作业总量:{{ subItem.workInputName }}{{ subItem.workInputQuantity }}{{ subItem.unit }}
                    </div> -->

                      <div style="display: flex;margin-bottom: 0.5rem;margin-top: 0.5rem;">
                        <el-image v-if="subItem.workImage.includes(',')" style="height: 40px" v-for="(item, index) in subItem.workImage.split(',')" :key="index" :src="item != undefined ? item : ''" :preview-src-list="subItem.workImage != undefined ? subItem.workImage.split(',') : []" fit="contain"> </el-image>
                        <el-image v-else style="height: 40px" :src="subItem.workImage" :preview-src-list="subItem.workImage" fit="contain"> </el-image>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </div>
    </ul>
  </div>
</template>

<script type="text/babel">
import Vue from 'vue'
export default Vue.component('Timeline', {
  name: 'Timeline',
  props: {
    timelineList: {
      type: Array,
      default: () => {
        return []
      }
    },
    timeLineArr_farm: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      show: false
    }
  },
  mounted() {},
  methods: {
    // 将鼠标滚轮上下变成左右事件
    ONMouseWheel(e) {
      console.log(1)
      // wheelDelta的值为正（120.240...）则是鼠标向上；为负（-120，-240）则是向下。
      // 因为要兼容浏览器，所以才写成 -e.wheelDelta || -e.deltaY.部分浏览器这个e.wheelDeltaY值是没有的可能是null，部分浏览器e.deltaY这个值是没有的可能是null，
      let eventDelta = -e.wheelDelta || -e.deltaY * 40
      let outsideWrap = this.$refs.outsideWrap
      outsideWrap.scrollLeft = outsideWrap.scrollLeft + eventDelta / 2
    },
    scrollEvent(e) {
      this.$emit('scrollEvent', e)
    },
    handleBottomClick() {
      this.$emit('handleBottomClick')
    }
  }
})
</script>

<style scoped lang="scss">
.title_box {
  display: flex;
  justify-content: center;
  width: 100%;
}
.title_ {
  width: 90%;
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  color: #666666;
  white-space: normal;
}
/* 整个滚动条 */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/* 滚动条上的滚动滑块 */
::-webkit-scrollbar-thumb {
  background-color: #49b1f5;
  /* 关键代码 */
  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.4) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.4) 75%, transparent 75%, transparent);
  border-radius: 32px;
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: #dbeffd;
  border-radius: 32px;
}

.text_content {
  margin-top: 0.5rem;
  // margin-left: 1rem;
  // text-align: left !important;
  // display: grid;
  // grid-template-columns: 1fr 1fr;
}

.img_box {
  margin-left: 25px;
  margin-right: 25px;

  display: grid;
  grid-template-columns: 1fr;

  .top_img {
    margin-top: 120px;
  }

  .bottom_img {
    margin-top: 20px;
  }
}

ul.timeline-wrapper {
  list-style: none;
  margin: 0;
  padding: 0;
  padding: 330px 20px;
  white-space: nowrap;
  overflow-x: scroll;
}

/* 时间线 */
.timeline-item {
  position: relative;
  top: -140px;
  display: inline-block;

  .timeline-box {
    text-align: center;

    // position: absolute;
    display: flex;
    align-items: center;

    .out-circle {
      width: 16px;
      height: 16px;
      background: rgba(14, 116, 218, 0.3);
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.4);
      /*opacity: 0.1;*/
      border-radius: 50%;
      display: flex;
      align-items: center;
      cursor: pointer;

      .in-circle {
        width: 8px;
        height: 8px;
        margin: 0 auto;
        background: rgba(14, 116, 218, 1);
        border-radius: 50%;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
      }

      .timeline-date {
        color: #333;
        margin-top: 40px;

        .father-text {
          font-weight: 900;
          font-size: 16px;
          margin-left: -15px;
        }
      }
    }

    .long-line {
      min-width: 300px;
      height: 2px;
      background: rgba(14, 116, 218, 0.2);
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.3);
      display: flex;
      flex-direction: revert;
      justify-content: space-around;

      .bottom-item-box {
        margin-left: 0.5rem;
        margin-top: 10px;
        position: relative;
      }

      .sub-item-box {
        margin-left: 0.5rem;
        margin-top: -20px;
        position: relative;
      }

      .sub-line-box {
        // cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .children-line-box {
          width: 0px;
          border-left: 1px solid rgba(14, 116, 218, 0.3);
        }

        .children-box {
          // flex-wrap: wrap;
          color: #333;
          font-weight: bold;
          padding-top: 0.5rem;
          align-items: center;
          // padding-bottom: 1rem;
          text-align: center;
        }
        .a89 {
          padding-top: 20px;
          // line-height: 60px;
        }
        .a895 {
          color: #ffff !important;
        }
        .b69 {
          font-weight: 400;
          font-size: 12px;
          color: #666666;
          line-height: 17px;
          text-align: center;
          font-style: normal;
          padding-top: 10px;
        }
      }

      .top-line-box {
        margin-top: -120px;
        min-width: 170px;
        height: 80px;
        // border: 1px solid #2f91ff;
      }

      .toper {
        border: 1px solid #aa6fff !important;
      }

      .toper_wenkong {
        border: 1px solid #ffc41d !important;
      }

      .toper_fengji {
        border: 1px solid #f99220 !important;
      }

      .toper_gj {
        // margin-top: -250px !important;
        // border: 1px solid #df2828 !important;
      }
      .toper_gj_ {
        margin-top: -300px !important;
      }
      .toper_guangai {
        margin-top: -250px !important;
        border: 1px solid #aa5a27 !important;
      }

      .bottom-line-box {
        display: block !important;
        margin-top: 37px;
        min-width: 210px;
        min-height: 100px;
        border-radius: 5px;
        // background-color: #ec4957;
      }

      .top-line {
        margin: auto;
        margin-top: -1rem;
        height: 80px !important;
        width: 1px !important;
        border: 1px dashed #4299fa;
        align-items: center;
      }

      .co2-line {
        margin: auto;
        margin-top: -1rem;
        height: 80px !important;
        width: 1px !important;
        border: 1px dashed #f99220;
        align-items: center;
      }

      .jr-line {
        margin: auto;
        margin-top: -1rem;
        height: 80px !important;
        width: 1px !important;
        border: 1px dashed #ffc523;
        align-items: center;
      }

      .f-line {
        margin: auto;
        margin-top: -1rem;
        height: 80px !important;
        width: 1px !important;
        border: 1px dashed #aa6fff;
        align-items: center;
      }

      .toper-line {
        margin: auto;
        margin-top: -1rem;
        width: 1px !important;
        align-items: center;
        border: 1px dashed #f9901b;
        height: 160px !important;
      }

      .gj-line {
        margin: auto;
        margin-top: -1rem;
        width: 1px !important;
        align-items: center;
        border: 1px dashed #ee4462;
        height: 160px !important;
      }

      .bottom-line {
        margin: auto;
        margin-top: 0.5rem;
        height: 80px !important;
        width: 1px !important;
        border: 1px dashed #4299fa;
        align-items: center;
      }

      .top-children-box {
        min-width: 170px;
        height: 90px;
        background: #c2dcf5;
        border-radius: 5px;
        margin: 0.1rem;
      }

      .toper-children-box {
        min-width: 150px;
        height: 74px;
        background: linear-gradient(360deg, #7f1eff 0%, #b481ff 100%) !important;
        border-radius: 35px;
        margin: 0.1rem;
      }

      .toper-guangai-box {
        min-width: 150px;
        height: 74px;
        background: linear-gradient(360deg, #b05e2a 0%, #e38244 100%) !important;
        border-radius: 35px;
        margin: 0.1rem;
      }

      .toper-gj-box {
        min-width: 170px;
        height: 90px;
        background: linear-gradient(360deg, #f31818 0%, #ec6f75 100%) !important;
        border-radius: 5px;
        margin: 0.1rem;
      }

      .toper-gj-box_ {
        min-width: 170px;
        min-height: 90px;
        background: linear-gradient(360deg, #ffa624 0%, #ffcd41 100%) !important;
        border-radius: 5px;
        margin: 0.1rem;
      }
      .toper-wenkong-box {
        min-width: 150px;
        height: 74px;
        background: linear-gradient(360deg, #ffc31c 0%, #ffcd41 100%) !important;
        border-radius: 35px;
        margin: 0.1rem;
      }

      .toper-fengji-box {
        min-width: 150px;
        height: 74px;
        background: linear-gradient(360deg, #f88b13 0%, #fda442 100%) !important;
        border-radius: 35px;
        margin: 0.1rem;
      }

      .bottom-children-box {
        color: black !important;
        // margin: 5px;
        // margin: auto;.
        margin-top: 0.2rem;
        min-width: 210px;
        min-height: 110px;
        // border: 1px solid #7cbdff;
        // border-radius: 35px;
        padding: 5px;
      }
    }
  }

  .timeline-content {
    box-sizing: border-box;
    margin-left: 20px;
    height: 106px;
    padding: 0 0 0 20px;
    text-align: left;
    margin-bottom: 30px;

    .timeline-title {
      font-size: 14px;
      word-break: break-all;
      margin-bottom: 16px;
      color: #333;
      font-weight: 500;
      /*display: inline;*/
    }

    .timeline-desc {
      font-size: 14px;
      color: #999999;
    }
  }
}
/* 时间线 */
.timeline-item2 {
  position: relative;
  top: 150px;
  // display: inline;
  display: inline-block;

  .timeline-box {
    text-align: center;

    // position: absolute;
    display: flex;
    align-items: center;

    .out-circle {
      width: 16px;
      height: 16px;
      background: rgba(14, 116, 218, 0.3);
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.4);
      /*opacity: 0.1;*/
      border-radius: 50%;
      display: flex;
      align-items: center;
      cursor: pointer;

      .in-circle {
        width: 8px;
        height: 8px;
        margin: 0 auto;
        background: rgba(14, 116, 218, 1);
        border-radius: 50%;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
      }

      .timeline-date {
        color: #333;
        margin-top: 40px;

        .father-text {
          font-weight: 900;
          font-size: 16px;
          margin-left: -15px;
        }
      }
    }

    .long-line {
      min-width: 300px;
      height: 2px;
      background: rgba(14, 116, 218, 0.2);
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.3);
      display: flex;
      flex-direction: revert;
      justify-content: space-around;

      .bottom-item-box {
        margin-left: 0.5rem;
        margin-top: 10px;
        position: relative;
      }

      .sub-item-box {
        margin-left: 0.5rem;
        margin-top: -20px;
        position: relative;
      }

      .sub-line-box {
        // cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .children-line-box {
          width: 0px;
          border-left: 1px solid rgba(14, 116, 218, 0.3);
        }

        .children-box {
          // flex-wrap: wrap;
          color: #333;
          font-weight: bold;
          padding-top: 0.5rem;
          align-items: center;
          // padding-bottom: 1rem;
          text-align: center;
        }
        .a89 {
          padding-top: 20px;
          // line-height: 60px;
        }
        .a895 {
          color: #ffff !important;
        }
        .b69 {
          font-weight: 400;
          font-size: 12px;
          color: #666666;
          line-height: 17px;
          text-align: center;
          font-style: normal;
          padding-top: 10px;
        }
      }

      .top-line-box {
        margin-top: -140px;
        min-width: 170px;
        height: 80px;
        // border: 1px solid #2f91ff;
      }

      .toper {
        border: 1px solid #aa6fff !important;
      }

      .toper_wenkong {
        border: 1px solid #ffc41d !important;
      }

      .toper_fengji {
        border: 1px solid #f99220 !important;
      }

      .toper_gj {
        // margin-top: -250px !important;
        // border: 1px solid #df2828 !important;
      }
      .toper_gj_ {
        margin-top: -120px !important;
      }
      .toper_guangai {
        margin-top: -250px !important;
        border: 1px solid #aa5a27 !important;
      }

      .bottom-line-box {
        display: block !important;
        margin-top: 10px;
        min-width: 210px;
        min-height: 100px;
        border-radius: 5px;
        background-color: #f7e1c9;
      }

      .top-line {
        margin: auto;
        margin-top: -1rem;
        height: 80px !important;
        width: 1px !important;
        border: 1px dashed #4299fa;
        align-items: center;
      }

      .co2-line {
        margin: auto;
        margin-top: -1rem;
        height: 80px !important;
        width: 1px !important;
        border: 1px dashed #f99220;
        align-items: center;
      }

      .jr-line {
        margin: auto;
        margin-top: -1rem;
        height: 80px !important;
        width: 1px !important;
        border: 1px dashed #ffc523;
        align-items: center;
      }

      .f-line {
        margin: auto;
        margin-top: -1rem;
        height: 80px !important;
        width: 1px !important;
        border: 1px dashed #aa6fff;
        align-items: center;
      }

      .toper-line {
        margin: auto;
        margin-top: -1rem;
        width: 1px !important;
        align-items: center;
        border: 1px dashed #f9901b;
        height: 160px !important;
      }

      .gj-line {
        margin: auto;
        margin-top: -1rem;
        width: 1px !important;
        align-items: center;
        border: 1px dashed #ee4462;
        height: 160px !important;
      }

      .bottom-line {
        margin: auto;
        margin-top: 0.5rem;
        height: 80px !important;
        width: 1px !important;
        border: 1px dashed #4299fa;
        align-items: center;
      }

      .top-children-box {
        min-width: 170px;
        height: 90px;
        background: #c2dcf5;
        border-radius: 5px;
        margin: 0.1rem;
      }

      .toper-children-box {
        min-width: 150px;
        height: 74px;
        background: linear-gradient(360deg, #7f1eff 0%, #b481ff 100%) !important;
        border-radius: 35px;
        margin: 0.1rem;
      }

      .toper-guangai-box {
        min-width: 150px;
        height: 74px;
        background: linear-gradient(360deg, #b05e2a 0%, #e38244 100%) !important;
        border-radius: 35px;
        margin: 0.1rem;
      }

      .toper-gj-box {
        min-width: 170px;
        height: 90px;
        background: linear-gradient(360deg, #ffa624 0%, #ffcd41 100%) !important;
        border-radius: 5px;
        margin: 0.1rem;
      }

      .toper-gj-box_ {
        min-width: 170px;
        min-height: 90px;
        background: linear-gradient(360deg, #ffa624 0%, #ffcd41 100%) !important;
        border-radius: 5px;
        margin: 0.1rem;
      }
      .toper-wenkong-box {
        min-width: 150px;
        height: 74px;
        background: linear-gradient(360deg, #ffc31c 0%, #ffcd41 100%) !important;
        border-radius: 35px;
        margin: 0.1rem;
      }

      .toper-fengji-box {
        min-width: 150px;
        height: 74px;
        background: linear-gradient(360deg, #f88b13 0%, #fda442 100%) !important;
        border-radius: 35px;
        margin: 0.1rem;
      }

      .bottom-children-box {
        color: black !important;
        margin: 5px;
        // margin: auto;.
        margin-top: 0.2rem;
        min-width: 210px;
        min-height: 110px;
        // border: 1px solid #7cbdff;
        // border-radius: 35px;
        padding: 5px;
      }
    }
  }

  .timeline-content {
    box-sizing: border-box;
    margin-left: 20px;
    height: 106px;
    padding: 0 0 0 20px;
    text-align: left;
    margin-bottom: 30px;

    .timeline-title {
      font-size: 14px;
      word-break: break-all;
      margin-bottom: 16px;
      color: #333;
      font-weight: 500;
      /*display: inline;*/
    }

    .timeline-desc {
      font-size: 14px;
      color: #999999;
    }
  }
}
.timeline-item:last-of-type .timeline-content {
  margin-bottom: 0;
}
.ns_title {
  display: flex;
  align-items: center;
  font-size: 14px;
}
.ns_img {
  width: 30px;
  margin-right: 10px;
}
.none {
  opacity: 0;
}
</style>
